module.exports = __webpack_public_path__ + "img/mv.0cdf2e4f.svg";